webpackJsonp([129],{

/***/ "VXOl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var underscore_extensions_1 = __webpack_require__("R0iF");
var AuthenticationSvc_1 = __webpack_require__("awAO");
exports.UPDATE_SUBSCRIPTION_CARD = 'website/subscription/updateCard';
exports.APPLY_COUPON = 'website/subscription/applyCoupon';
exports.CouponCompaniesNames = {
    prod: {
        AppSumo117: {
            title: 'AppSumo'
        },
        MightyDeals417: {
            title: 'MightyDeals'
        },
        StackSocial0718: {
            title: 'StackSocial'
        },
        'StackSocial0219-1A': {
            title: 'StackSocial'
        },
        defaultCompany: {
            title: 'Company'
        }
    },
    dev: {
        MightyDeals417: {
            title: 'AppSumo'
        },
        MightyDeals417Test: {
            title: 'MightyDeals'
        },
        StackSocial0718: {
            title: 'StackSocial'
        },
        'StackSocial0219-1A': {
            title: 'StackSocial'
        },
        defaultCompany: {
            title: 'Company'
        }
    }
}[ true ? 'prod' : 'dev'];
var SubscriptionSvc = (function () {
    SubscriptionSvc.$inject = ["$q", "$filter", "$http", "$rootScope", "$state", "TranslateSvc", "analyticSvc", "AuthenticationSvc", "affiliateSvc", "HttpSvc"];
    function SubscriptionSvc($q, $filter, $http, $rootScope, $state, TranslateSvc, analyticSvc, AuthenticationSvc, affiliateSvc, HttpSvc) {
        var _this = this;
        this.$q = $q;
        this.$filter = $filter;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.TranslateSvc = TranslateSvc;
        this.analyticSvc = analyticSvc;
        this.AuthenticationSvc = AuthenticationSvc;
        this.affiliateSvc = affiliateSvc;
        this.HttpSvc = HttpSvc;
        this.specialSubscriptionNames = ['WaveBigAgency', 'WaveSmallAgency'];
        this.handlerHttpResponse = function (res) {
            var deferred = _this.$q.defer();
            if (res && res.data && underscore_extensions_1.Utils.isApiError(res.data)) {
                deferred.reject(res.data.message);
                console.error('subscription error: ', res.data);
            }
            else {
                deferred.resolve(res.data);
            }
            return deferred.promise;
        };
        this.$rootScope.$on(AuthenticationSvc_1.USER_LOGOUT, function () {
            _this.upgradesDiscount = undefined;
            _this.cardDetailsCashed = undefined;
            _this.cardDetailsErrorMessage = undefined;
        });
    }
    SubscriptionSvc.isStripeError = function (error) {
        return error && error.message && error.type;
    };
    Object.defineProperty(SubscriptionSvc.prototype, "product", {
        get: function () {
            return underscore_extensions_1.Utils.getProduct();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionSvc.prototype, "productParams", {
        get: function () {
            return { params: { product: this.product } };
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionSvc.prototype.getError = function (error) {
        if (!error)
            return null;
        if (_.isString(error)) {
            return (this.getStripeCouponError(error) ||
                this.getRequiredSubscriptionError(error) ||
                this.getStripeCardError(error) ||
                (this.TranslateSvc.has(error.toLowerCase()) &&
                    this.TranslateSvc.get(error.toLowerCase())) ||
                error);
        }
        else if (SubscriptionSvc.isStripeError(error)) {
            return error.message;
        }
        else {
            return error;
        }
    };
    SubscriptionSvc.prototype.findSubscriptionByName = function (displayName) {
        var _this = this;
        // search in upgrades
        var upgrade = this.getUpgradesByName(displayName);
        if (upgrade)
            return this.$q.resolve(upgrade);
        // search in current subscription
        return this.getDowngradesByName(null, displayName).then(function (downgrade) {
            if (downgrade)
                return downgrade;
            var currentSubscription = _this.getDetails();
            if (currentSubscription.displayName === displayName)
                return _this.$q.resolve(currentSubscription);
            return _this.$q.reject("Incorrect displayName = " + displayName);
        });
    };
    SubscriptionSvc.prototype.getPredictPrice = function (_a) {
        var displayName = _a.displayName, coupon = _a.coupon, params = tslib_1.__rest(_a, ["displayName", "coupon"]);
        var _this = this;
        return this.findSubscriptionByName(displayName)
            .then(function (_a) {
            var name = _a.name;
            return _this.HttpSvc('subscription/calculate').secureGet({
                params: tslib_1.__assign({}, params, { name: name, coupon: coupon || undefined })
            });
        })
            .then(function (r) { return r.data; });
    };
    SubscriptionSvc.prototype.isStripe = function () {
        return !this.isStripeError && options.user.isStripe();
    };
    SubscriptionSvc.prototype.getAnnualSave = function (upgrade) {
        if (upgrade === void 0) { upgrade = this.getDetails(); }
        return (upgrade.monthlyPrice * 12 - upgrade.annualPrice) / 100;
    };
    SubscriptionSvc.prototype.getAnnualPrice = function (details, discountPercentOff) {
        if (details === void 0) { details = this.getDetails(); }
        if (discountPercentOff === void 0) { discountPercentOff = details.discount && details.discount.percentOff; }
        return this.round((details.annualPrice * this.calcDiscount(discountPercentOff)) /
            100 /
            12);
    };
    SubscriptionSvc.prototype.getMonthlyPrice = function (details, discountPercentOff) {
        if (details === void 0) { details = this.getDetails(); }
        if (discountPercentOff === void 0) { discountPercentOff = details.discount && details.discount.percentOff; }
        return this.round((details.monthlyPrice * this.calcDiscount(discountPercentOff)) / 100);
    };
    SubscriptionSvc.prototype.isFree = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        var freeSubscriptions = ['WaveFree', 'Free'];
        return freeSubscriptions.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isHigh = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        var highSubscriptions = ['WaveBusiness', 'Business'];
        return highSubscriptions.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isSpecial = function (currentSubscription) {
        if (currentSubscription === void 0) { currentSubscription = this.getDetails(); }
        return this.specialSubscriptionNames.includes(currentSubscription.name);
    };
    SubscriptionSvc.prototype.isAppSumo = function (_a) {
        var _b = _a === void 0 ? this.getDetails() : _a, billingPeriod = _b.billingPeriod, discount = _b.discount;
        return (discount &&
            (discount.provider === 'AppSumo117' ||
                (!true &&
                    discount.provider === 'MightyDeals417')));
    };
    SubscriptionSvc.prototype.isCurrentOldPlan = function () {
        var oldPlans = [
            'WavePro',
            'WaveAgency',
            'WaveAgency2',
            'WaveUltimate2'
        ];
        var name = this.getDetails().name;
        return oldPlans.includes(name);
    };
    SubscriptionSvc.prototype.isSameOldPlan = function (period, planName) {
        var currentPlanName = this.getDetails().name;
        var monthlyPlanMap = {
            WavePro: 'Agency',
            WaveAgency2: 'Corporate'
        };
        var annualPlanMap = {
            WavePro: 'Pro',
            WaveAgency2: 'Agency',
            WaveUltimate2: 'Corporate'
        };
        var currentUserPlan = period === 'annual'
            ? annualPlanMap[currentPlanName]
            : monthlyPlanMap[currentPlanName];
        var isSamePlan = currentUserPlan === planName;
        return isSamePlan && this.isCurrentOldPlan();
    };
    SubscriptionSvc.prototype.getDetails = function () {
        var product = this.product.toLowerCase();
        var subscription = options.user.subscriptionDetails[product];
        return this.prepareSubscription(subscription);
    };
    SubscriptionSvc.prototype.setUpgradesDiscount = function () {
        var _this = this;
        this.affiliateSvc
            .getAffiliateUser()
            .then(function (affiliateInfo) {
            _this.upgradesDiscount = affiliateInfo.discount;
        });
    };
    SubscriptionSvc.prototype.getSale = function () {
        var _this = this;
        return this.HttpSvc('sale.json')
            .setApiUrl('https://assets.animatron.com')
            .get(this.productParams)
            .then(this.handlerHttpResponse)
            .catch(function (errMsg) { return _this.$q.reject(errMsg); });
    };
    SubscriptionSvc.prototype.getCardDetails = function () {
        var _this = this;
        return this.HttpSvc('subscription', 'history')
            .secureGet(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function (res) {
            _this.isStripeError = res.card.type === 'N/A';
            _this.checkExpired(res.card.expires);
            _this.cardDetailsCashed = res;
            return res;
        })
            .catch(function (errMsg) {
            _this.isStripeError = true;
            _this.cardDetailsErrorMessage = errMsg;
            return _this.$q.reject(errMsg);
        });
    };
    SubscriptionSvc.prototype.getUpgradesByName = function (name) {
        var upgrade = this.getDetails().upgrades.filter(function (upgradeItem) {
            return upgradeItem &&
                (upgradeItem.name === name || upgradeItem.displayName === name);
        })[0];
        return upgrade && this.prepareSubscription(upgrade);
    };
    SubscriptionSvc.prototype.getDowngradesByName = function (name, displayName) {
        var _this = this;
        return this.getDowngrades().then(function (downgrades) {
            var downgrade = downgrades.filter(function (downgradeItem) {
                return downgradeItem &&
                    (downgradeItem.name === name ||
                        downgradeItem.displayName === displayName);
            })[0];
            return downgrade && _this.prepareSubscription(downgrade);
        });
    };
    SubscriptionSvc.prototype.getUpgrades = function () {
        return this.getDetails().upgrades.filter(function (upgrade) {
            return !upgrade.excludeFromUI &&
                !upgrade.hidden &&
                upgrade.name !== 'WaveEnterprise';
        });
    };
    SubscriptionSvc.prototype.getDowngrades = function () {
        return this.HttpSvc('subscription', 'downgrade')
            .secureGet(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function (downgrades) {
            return downgrades.filter(function (downgrade) { return !downgrade.excludeFromUI && !downgrade.hidden; });
        });
    };
    SubscriptionSvc.prototype.cancelSubscription = function () {
        var _this = this;
        var _a = this.getDetails(), displayName = _a.displayName, billingPeriod = _a.billingPeriod;
        return this.HttpSvc('subscription', 'cancel')
            .secureDelete(this.productParams)
            .then(this.handlerHttpResponse)
            .then(function () {
            _this.cardDetailsCashed = null;
            _this.cardDetailsErrorMessage = null;
            _this.analyticSvc.changeSubscription('downgrade', displayName, billingPeriod);
            return _this.AuthenticationSvc.updateUser();
        });
    };
    SubscriptionSvc.prototype.checkExpired = function (expires) {
        var dateArr = expires.split('/');
        if (dateArr.length === 2) {
            var monthDays = underscore_extensions_1.Utils.getMonthDaysCount().toString();
            dateArr.splice(1, 0, monthDays);
        }
        var formattedDate = dateArr.join('/');
        var expiredDate = new Date(formattedDate).getTime();
        var currentDate = _.now();
        this.isExpired = currentDate >= expiredDate;
    };
    SubscriptionSvc.prototype.changeSubscription = function (params) {
        var _this = this;
        var request = function () {
            return _this.HttpSvc('subscription', 'change').securePut(params, {
                headers: _this.analyticSvc.getGaHeader()
            });
        };
        return this.changeSubscriptionErrorHandler(request);
    };
    SubscriptionSvc.prototype.changeSubscriptionErrorHandler = function (request) {
        var _this = this;
        var getErrorPromise = function () {
            var message = 'credit.card.processing.error.[expired_card]';
            var deferred = _this.$q.defer();
            deferred.resolve({ data: { code: 400, message: message } });
            return deferred.promise;
        };
        return this.isExpired ? getErrorPromise() : request();
    };
    SubscriptionSvc.prototype.updateCard = function (token) {
        var _this = this;
        var url = options.apiDomain + "/subscription/card/update";
        var headers = _.extend({
            'Content-Type': 'application/json'
        }, options.headers);
        return this.$http
            .post(url, { token: token }, { headers: headers })
            .then(function (r) {
            _this.$rootScope.$emit(exports.UPDATE_SUBSCRIPTION_CARD);
            return r;
        })
            .catch(function (err) {
            return err.status !== -1
                ? err
                : {
                    data: {
                        code: 400,
                        message: 'subscription.update-card.default-error'
                    }
                };
        });
    };
    SubscriptionSvc.prototype.round = function (num) {
        return Math.ceil(num);
    };
    SubscriptionSvc.prototype.calcDiscount = function (discount) {
        return discount ? 1 - discount / 100 : 1;
    };
    SubscriptionSvc.prototype.makeSpecialSubscription = function (subscription) {
        subscription.monthlyPrice = undefined;
        return subscription;
    };
    SubscriptionSvc.prototype.prepareSubscription = function (subscription) {
        return this.specialSubscriptionNames.includes(subscription.name)
            ? this.makeSpecialSubscription(subscription)
            : subscription;
    };
    SubscriptionSvc.prototype.showSubscriptionCanceledMessage = function () {
        var details = this.getDetails();
        var currentPlan = details.displayName;
        var expTime = details.expirationDate;
        var date = this.$filter('date')(expTime * 1000, 'short');
        var msg = expTime
            ? "Subscription will be canceled on " + date
            : 'Already canceled';
        _.notification.showSuccess(msg);
    };
    SubscriptionSvc.prototype.getStripeCardError = function (error) {
        var matched = error.match(/\[([A-Za-z_]+)\]/);
        var stripeKey = matched && matched[1];
        return stripeKey && this.TranslateSvc.has(stripeKey)
            ? this.TranslateSvc.get(stripeKey)
            : null;
    };
    SubscriptionSvc.prototype.getStripeCouponError = function (error) {
        var errorsCode = [
            'Coupon expired',
            'No such coupon',
            'Coupon is not valid',
            'Coupon inapplicable'
        ];
        var reg = new RegExp(errorsCode.join('|'));
        var isCouponError = _.isString(error) && reg.test(error);
        return isCouponError && this.TranslateSvc.get('coupon.error');
    };
    SubscriptionSvc.prototype.getRequiredSubscriptionError = function (error) {
        var isRequiredSubscriptionError = _.isString(error) && /required subscription:/.test(error);
        if (!isRequiredSubscriptionError)
            return false;
        var _a = error.match(/\(([0-9a-zA-Z]+)\|([0-9a-zA-Z]+)\)/), plan = _a[1], period = _a[2];
        var subscriptionName = plan + " " + period;
        var productName = underscore_extensions_1.Utils.getProduct().toLowerCase();
        var coupon = this.$state.params.coupon;
        var upgradeParams = underscore_extensions_1.Utils.toParams({
            plan: plan,
            coupon: coupon,
            period: period.toLowerCase()
        });
        var productUrl = underscore_extensions_1.Utils.getProduct() === 'WAVE' ? '' : "/" + productName;
        var url = productUrl + "/pricing/upgrade?" + upgradeParams;
        return this.TranslateSvc.get('required.subscription.error', url, subscriptionName);
    };
    return SubscriptionSvc;
}());
exports.SubscriptionSvc = SubscriptionSvc;
angular
    .module('animatronApp.SubscriptionSvc', [])
    .service('subscriptionSvc', SubscriptionSvc);


/***/ })

});


// WEBPACK FOOTER //
// javascripts/129-c7c98a0cc108ea8b91f3.min.js